import React, { useState } from 'react';
import { ExternalLink, Info } from 'lucide-react';
import { motion } from 'framer-motion';
import { SelectDropdown } from './SelectDropdown';
const FREQUENCY_OPTIONS = [{
  value: 'daily',
  label: 'Daily'
}, {
  value: 'weekly',
  label: 'Weekly'
}, {
  value: 'immediately',
  label: 'Immediately'
}];
export function SettingsPanels() {
  // Notification Settings State
  const [notificationScope, setNotificationScope] = useState('account');
  const [gradingWeb, setGradingWeb] = useState(true);
  const [gradingEmail, setGradingEmail] = useState(true);
  const [gradingFrequency, setGradingFrequency] = useState('daily');
  const [updatesWeb, setUpdatesWeb] = useState(true);
  const [updatesEmail, setUpdatesEmail] = useState(false);
  const [updatesFrequency, setUpdatesFrequency] = useState('daily');
  const [activityWeb, setActivityWeb] = useState(true);
  const [activityEmail, setActivityEmail] = useState(true);
  const [activityFrequency, setActivityFrequency] = useState('daily');
  const [newQuestionWeb, setNewQuestionWeb] = useState(false);
  const [newQuestionEmail, setNewQuestionEmail] = useState(false);
  const [newQuestionFrequency, setNewQuestionFrequency] = useState('daily');
  const [newDiscussionWeb, setNewDiscussionWeb] = useState(false);
  const [newDiscussionEmail, setNewDiscussionEmail] = useState(false);
  const [newDiscussionFrequency, setNewDiscussionFrequency] = useState('daily');
  // Linked Accounts State
  const [linkedAccounts, setLinkedAccounts] = useState({
    apple: false,
    facebook: false,
    google: true,
    microsoft: false
  });
  return <div data-phoebe-tour="settings" className="space-y-6" data-id="element-1592" data-mp="37rvfk5pp69ui">
      {/* Notifications Section */}
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3
    }} className="bg-white rounded-xl shadow-sm border border-gray-200" data-id="element-1593" data-mp="3cj3kopjzv91v">
        <div className="p-6 border-b border-gray-200" data-id="element-1594" data-mp="2k1808zdgchxx">
          <h2 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1595" data-mp="3nd6s1ij1vyis">Notifications</h2>
          <div className="text-sm text-gray-600 space-y-2" data-id="element-1596" data-mp="3nb3u8cbnp13i">
            <p data-id="element-1597" data-mp="3idu5kyw3ctgq">
              Account-level settings apply to all courses. Notifications for
              individual courses can be changed within each course and will
              override account-level settings.
            </p>
            <p data-id="element-1598" data-mp="3s6j30put46t2">
              Daily notifications are delivered at 22:00 UTC. Weekly
              notifications are delivered at 22:00 UTC Every Sunday.
            </p>
            <p className="text-[#30718D]" data-id="element-1599" data-mp="2zh2fa5i4te36">
              Notifications for certain activities are enabled by default,{' '}
              <a href="#" className="underline hover:text-[#265a70]" data-id="element-1600" data-mp="3dd66rr1mf8by">
                as detailed here
              </a>
              <ExternalLink size={12} className="inline ml-1" data-id="element-1601" data-mp="soru59epsm89" />
            </p>
          </div>
        </div>

        <div className="p-6" data-id="element-1602" data-mp="nqgjwxkic9pi">
          {/* Notification Scope Selector */}
          <div className="mb-6" data-id="element-1603" data-mp="nsb9ip6q4pzx">
            <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1604" data-mp="w6plpjal93zo">
              Select notifications for
            </label>
            <SelectDropdown fullWidth ariaLabel="Select notifications for" value={notificationScope} onChange={setNotificationScope} options={[{
            value: 'account',
            label: 'Account'
          }, {
            value: 'course1',
            label: 'Course 1'
          }, {
            value: 'course2',
            label: 'Course 2'
          }]} data-id="element-1605" data-mp="109vp8j6bgh2g" />
            <p className="text-xs text-gray-500 mt-1" data-id="element-1606" data-mp="1jvi92rd5a3io">Applies to all courses</p>
          </div>

          {/* Notification Settings Table */}
          <div className="space-y-6" data-id="element-1607" data-mp="155jeeyksta7y">
            {/* Grading */}
            <div data-id="element-1608" data-mp="1a5fiexthx1ni">
              <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-1609" data-mp="1a4w2fmneonc4">Grading</h3>
              <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 border-b border-gray-100 gap-3" data-id="element-1610" data-mp="1xvjd2fophr2d">
                <div className="flex-1" data-id="element-1611" data-mp="22p4dsfhooz59">
                  <span className="text-sm text-gray-700" data-id="element-1612" data-mp="e1qa27fxwxma">
                    Essay assignment grade received
                  </span>
                </div>
                <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-1613" data-mp="a1pwsq4kusgt">
                  <div className="flex items-center gap-2" data-id="element-1614" data-mp="5124800pa3kh">
                    <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1615" data-mp="1ywu8x8zl9c">
                      Web
                    </span>
                    <button onClick={() => setGradingWeb(!gradingWeb)} aria-label="Toggle web notifications for essay assignment grades" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${gradingWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1616" data-mp="xnwe62zw5kjp">
                      <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${gradingWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1617" data-mp="j1371l0izl2l" />
                    </button>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1618" data-mp="1bo7493tdmv3t">
                    <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1619" data-mp="1j0dermskgcpx">
                      Email
                    </span>
                    <button onClick={() => setGradingEmail(!gradingEmail)} aria-label="Toggle email notifications for essay assignment grades" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${gradingEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1620" data-mp="1o09gtghpdu2u">
                      <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${gradingEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1621" data-mp="21zrbudlle3kn" />
                    </button>
                  </div>
                  <SelectDropdown size="sm" menuAlign="right" ariaLabel="Essay assignment grade received notification frequency" value={gradingFrequency} onChange={setGradingFrequency} options={FREQUENCY_OPTIONS} data-id="element-1622" data-mp="2bq3ug09ujmo5" />
                </div>
              </div>
            </div>

            {/* Updates */}
            <div data-id="element-1623" data-mp="2ppdbf25vmkt6">
              <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-1624" data-mp="2potp79971a9c">Updates</h3>
              <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 border-b border-gray-100 gap-3" data-id="element-1625" data-mp="qkllsrg5b5xg">
                <div className="flex-1" data-id="element-1626" data-mp="limhnfcl04zg">
                  <span className="text-sm text-gray-700" data-id="element-1627" data-mp="zcnkolakge5m">Course updates</span>
                </div>
                <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-1628" data-mp="ukvsy7foc2dw">
                  <div className="flex items-center gap-2" data-id="element-1629" data-mp="19abd34kp99km">
                    <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1630" data-mp="198qm1oxlg8ri">
                      Web
                    </span>
                    <button onClick={() => setUpdatesWeb(!updatesWeb)} aria-label="Toggle web notifications for course updates" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${updatesWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1631" data-mp="1iazt24tnlk05">
                      <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${updatesWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1632" data-mp="3k2uza4x54waz" />
                    </button>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1633" data-mp="35yxdyi48ii20">
                    <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1634" data-mp="39xd1qo853ugh">
                      Email
                    </span>
                    <button onClick={() => setUpdatesEmail(!updatesEmail)} aria-label="Toggle email notifications for course updates" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${updatesEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1635" data-mp="2w4x3s1u3immf">
                      <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${updatesEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1636" data-mp="2r8ptxxykwqz7" />
                    </button>
                  </div>
                  <SelectDropdown size="sm" menuAlign="right" ariaLabel="Course updates notification frequency" value={updatesFrequency} onChange={setUpdatesFrequency} options={FREQUENCY_OPTIONS} data-id="element-1637" data-mp="2i7i9aiozjonl" />
                </div>
              </div>
            </div>

            {/* Discussions */}
            <div data-id="element-1638" data-mp="1ozsxqxrjyjyl">
              <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-1639" data-mp="1p2ezuhvoc79f">
                Discussions
              </h3>
              <div className="space-y-3" data-id="element-1640" data-mp="1fahnv8wudb9n">
                <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 border-b border-gray-100 gap-3" data-id="element-1641" data-mp="1f9g48g1rfggb">
                  <div className="flex-1 flex items-center gap-2" data-id="element-1642" data-mp="1b8nu7kl2d7iz">
                    <span className="text-sm text-gray-700" data-id="element-1643" data-mp="16aujqfcq9rcw">
                      Activity notifications
                    </span>
                    <Info size={14} className="text-gray-400" data-id="element-1644" data-mp="11ct4k5ifac6p" />
                  </div>
                  <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-1645" data-mp="wc5bleamvl9u">
                    <div className="flex items-center gap-2" data-id="element-1646" data-mp="sbd52st5buh9">
                      <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1647" data-mp="2qpeegn8oc8j4">
                        Web
                      </span>
                      <button onClick={() => setActivityWeb(!activityWeb)} aria-label="Toggle web notifications for discussion activity" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${activityWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1648" data-mp="2mpe2d991s9f8">
                        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${activityWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1649" data-mp="i5ld9cc2hzb9" />
                      </button>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-1650" data-mp="3lo54cbj0ez4h">
                      <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1651" data-mp="3qln87ni66o5m">
                        Email
                      </span>
                      <button onClick={() => setActivityEmail(!activityEmail)} aria-label="Toggle email notifications for discussion activity" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${activityEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1652" data-mp="3umqmi5kkkc4q">
                        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${activityEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1653" data-mp="1evcgbzyfcuso" />
                      </button>
                    </div>
                    <SelectDropdown size="sm" menuAlign="right" ariaLabel="Activity notifications frequency" value={activityFrequency} onChange={setActivityFrequency} options={FREQUENCY_OPTIONS} data-id="element-1654" data-mp="8u8wiyhf9za0" />
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 border-b border-gray-100 gap-3" data-id="element-1655" data-mp="3h3saea3rs0s0">
                  <div className="flex-1" data-id="element-1656" data-mp="3m3ogqfzxw4aq">
                    <span className="text-sm text-gray-700" data-id="element-1657" data-mp="3m4pvaug5z8x7">
                      New question posts
                    </span>
                  </div>
                  <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-1658" data-mp="3v4curapc24nm">
                    <div className="flex items-center gap-2" data-id="element-1659" data-mp="16c0k6lou8dsg">
                      <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1660" data-mp="16dk18eibisva">
                        Web
                      </span>
                      <button onClick={() => setNewQuestionWeb(!newQuestionWeb)} aria-label="Toggle web notifications for new question posts" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newQuestionWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1661" data-mp="2uvmwuuwbv97m">
                        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newQuestionWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1662" data-mp="2h3q7gym1ndex" />
                      </button>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-1663" data-mp="2759bfn8908m0">
                      <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1664" data-mp="233xknedn1hc8">
                        Email
                      </span>
                      <button onClick={() => setNewQuestionEmail(!newQuestionEmail)} aria-label="Toggle email notifications for new question posts" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newQuestionEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1665" data-mp="1y5w2qwry7o2c">
                        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newQuestionEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1666" data-mp="fhujic2le5cv" />
                      </button>
                    </div>
                    <SelectDropdown size="sm" menuAlign="right" ariaLabel="New question posts notification frequency" value={newQuestionFrequency} onChange={setNewQuestionFrequency} options={FREQUENCY_OPTIONS} data-id="element-1667" data-mp="6izfn6n0t7cq" />
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 gap-3" data-id="element-1668" data-mp="13871ygvgrkhp">
                  <div className="flex-1" data-id="element-1669" data-mp="p8fgxw6j53u7">
                    <span className="text-sm text-gray-700" data-id="element-1670" data-mp="p7nw9geh0qip">
                      New discussion posts
                    </span>
                  </div>
                  <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-1671" data-mp="39xlmfgvnf9kh">
                    <div className="flex items-center gap-2" data-id="element-1672" data-mp="3ex7wxik3ebpl">
                      <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1673" data-mp="3eyj2nnx3ltjc">
                        Web
                      </span>
                      <button onClick={() => setNewDiscussionWeb(!newDiscussionWeb)} aria-label="Toggle web notifications for new discussion posts" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newDiscussionWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1674" data-mp="32em1v7wgbbzj">
                        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newDiscussionWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1675" data-mp="2nppmeps2ewow" />
                      </button>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-1676" data-mp="2xfsp5hoznp0f">
                      <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1677" data-mp="2xhdn7haihq31">
                        Email
                      </span>
                      <button onClick={() => setNewDiscussionEmail(!newDiscussionEmail)} aria-label="Toggle email notifications for new discussion posts" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newDiscussionEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1678" data-mp="24ygbqd6k61vq">
                        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newDiscussionEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1679" data-mp="2il5ow8kqupqi" />
                      </button>
                    </div>
                    <SelectDropdown size="sm" menuAlign="right" ariaLabel="New discussion posts notification frequency" value={newDiscussionFrequency} onChange={setNewDiscussionFrequency} options={FREQUENCY_OPTIONS} data-id="element-1680" data-mp="2sd2zbd3xhdo6" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Linked Accounts Section */}
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      delay: 0.1
    }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1681" data-mp="3b9b9mvbsseqc">
        <div className="p-6 border-b border-gray-200" data-id="element-1682" data-mp="3u6mink1h013k">
          <h2 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1683" data-mp="3u8fq31jwqpcm">
            Linked Accounts
          </h2>
          <p className="text-sm text-gray-600" data-id="element-1684" data-mp="3pev3e5nrlhsq">
            You can link your identity accounts to simplify signing in.
          </p>
        </div>

        <div className="p-6 space-y-4" data-id="element-1685" data-mp="3gfzugltc5tlq">
          {/* Apple */}
          <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-1686" data-mp="3gdn4bldfccxl">
            <div data-id="element-1687" data-mp="gy8ll5d8u90x">
              <div className="text-sm font-semibold text-gray-900 mb-1" data-id="element-1688" data-mp="cyrey8m2z5u6">
                Apple
              </div>
              {linkedAccounts.apple && <div className="text-xs text-gray-500" data-id="element-1689" data-mp="7yllcmw9399g">
                  Linked account: user@icloud.com
                </div>}
            </div>
            <button onClick={() => setLinkedAccounts({
            ...linkedAccounts,
            apple: !linkedAccounts.apple
          })} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-1690" data-mp="32xv04618a2d">
              {linkedAccounts.apple ? 'Unlink' : 'Sign in with Apple'}
            </button>
          </div>

          {/* Facebook */}
          <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-1691" data-mp="2u69j984a92z9">
            <div data-id="element-1692" data-mp="2g7066hbdiozi">
              <div className="text-sm font-semibold text-gray-900 mb-1" data-id="element-1693" data-mp="2g9mbeaasksek">
                Facebook
              </div>
              {linkedAccounts.facebook && <div className="text-xs text-gray-500" data-id="element-1694" data-mp="26gfab1n33yka">
                  Linked account: user@facebook.com
                </div>}
            </div>
            <button onClick={() => setLinkedAccounts({
            ...linkedAccounts,
            facebook: !linkedAccounts.facebook
          })} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-1695" data-mp="2ba9r9xbb1zfo">
              {linkedAccounts.facebook ? 'Unlink' : 'Sign in with Facebook'}
            </button>
          </div>

          {/* Google */}
          <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-1696" data-mp="1sjryjsqh33ub">
            <div data-id="element-1697" data-mp="18xzwqe7mkyjn">
              <div className="flex items-center gap-2 mb-1" data-id="element-1698" data-mp="13wu2gbybh380">
                <span className="text-sm font-semibold text-gray-900" data-id="element-1699" data-mp="13ydj43nvxgab">
                  Google
                </span>
                {linkedAccounts.google && <span className="px-2 py-0.5 bg-[#007558]/10 text-[#007558] text-xs font-medium rounded" data-id="element-1700" data-mp="1dv06p07lilg1">
                    Linked
                  </span>}
              </div>
              {linkedAccounts.google && <div className="text-xs text-gray-500" data-id="element-1701" data-mp="1mvy7zaqngeux">
                  Linked account: linda.taylor@gmail.com
                </div>}
            </div>
            <button onClick={() => setLinkedAccounts({
            ...linkedAccounts,
            google: !linkedAccounts.google
          })} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${linkedAccounts.google ? 'text-[#30718D] hover:bg-[#30718D]/10' : 'border border-gray-300 hover:bg-gray-50'}`} data-id="element-1702" data-mp="21k1j0yjjugql">
              {linkedAccounts.google ? 'Unlink Google account' : 'Sign in with Google'}
            </button>
          </div>

          {/* Microsoft */}
          <div className="flex items-center justify-between py-3" data-id="element-1703" data-mp="3hwnfwjuj166i">
            <div data-id="element-1704" data-mp="3mx2rp6z5u5md">
              <div className="text-sm font-semibold text-gray-900 mb-1" data-id="element-1705" data-mp="3mwjjihzbavlj">
                Microsoft
              </div>
              {linkedAccounts.microsoft && <div className="text-xs text-gray-500" data-id="element-1706" data-mp="3qwaeyyzs9zwe">
                  Linked account: user@outlook.com
                </div>}
            </div>
            <button onClick={() => setLinkedAccounts({
            ...linkedAccounts,
            microsoft: !linkedAccounts.microsoft
          })} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-1707" data-mp="2z6ffwam4ivuj">
              {linkedAccounts.microsoft ? 'Unlink' : 'Sign in with Microsoft'}
            </button>
          </div>
        </div>
      </motion.div>
    </div>;
}